export default "__VITE_ASSET__DhoV2b5K__"